import debounce from "../../../utils/debounce";
import relativeApiFetch from "../../../utils/relative-api-fetch";

async function getSearchResults(query, limit) {
  try {
    const countPart = limit ? `&count=${limit}` : "";
    const results = await relativeApiFetch(
      `/api/search?searchString=${query}${countPart}`,
    );
    return results.json();
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
}

/**
 * Переключает класс у указанного элемента.
 *
 * @param {Element} element - Элемент, у которого нужно переключить класс.
 * @param {string} className - Имя класса, который нужно переключить.
 */
function toggleClass(element, className) {
  element.classList.toggle(className);
}

/**
 * Управляет поведением поиска на странице.
 * Эта функция добавляет обработчик событий на кнопку поиска
 */
function searchMaxWidth() {
  const searchInput = document.getElementById("searchinput");
  const searchButton = document.getElementById("searchbtn");
  const menu = document.getElementById("menu");

  const addSearchClass = () => {
    toggleClass(searchButton, "active-search");
    toggleClass(searchInput.parentNode, "show-search");
    toggleClass(searchInput, "show-search");
    searchInput.focus();

    setTimeout(() => {
      toggleClass(menu, "hide");
    }, 100);
  };

  searchButton.addEventListener("click", () => {
    searchInput.value = "";
    addSearchClass();
  });
}

/**
 * Управляет функциональностью поиска в меню.
 * Эта функция добавляет обработчики событий для поля ввода поиска и кнопки поиска.
 */
function searchMenu(searchInput, searchButton) {
  const searchInputValue = searchInput;
  const searchForm = document.getElementById("searchform");
  const searchResultsList = document.getElementById("search-results");

  let selectedResultItemIndex = -1;

  const noResultsMessage = document.createElement("li");
  noResultsMessage.textContent = "По вашему запросу ничего не найдено";
  noResultsMessage.classList.add("no-result", "text-16-r");
  noResultsMessage.style.display = "none";

  searchForm.addEventListener("submit", (event) => {
    if (selectedResultItemIndex === -1) {
      event.preventDefault();

      const searchString = searchInputValue.value;
      if (searchString) {
        window.location.href = `/search?searchString=${searchString}${
          window.portal.queryString ? `&${window.portal.queryString}` : ""
        }`;
      }
    }
  });

  const clearResults = () => {
    searchResultsList.innerHTML = "";
    searchResultsList.classList.remove("open-results");
    selectedResultItemIndex = -1;
  };

  const clearInput = () => {
    searchInputValue.value = "";
    clearResults();
    searchButton.classList.remove("is-search");
    searchButton.classList.add("search-icon");
  };

  const createResultItem = (result) => {
    const li = document.createElement("li");
    li.classList.add("result-item");
    li.setAttribute("id", result.uid);

    const link = document.createElement("a");
    link.href = `${result.link}${
      window.portal.queryString ? `?${window.portal.queryString}` : ""
    }`;
    link.target = "_self";
    link.classList.add("result-link");

    const text = document.createElement("span");
    text.textContent = result.title;
    text.classList.add("text-16-r");

    link.appendChild(text);
    li.appendChild(link);

    li.addEventListener("click", () => {
      searchInputValue.value = "";
      searchButton.classList.remove("is-search");
      searchButton.classList.add("search-icon");
      clearResults();
    });

    return li;
  };

  const updateSearchResultsList = async () => {
    const query = searchInput.value.trim();
    clearResults();

    if (query !== "") {
      const results = await getSearchResults(query, 6);

      if (results.length > 0) {
        results.forEach((result) => {
          searchResultsList.appendChild(createResultItem(result));
        });
        searchResultsList.classList.add("open-results");
      }
    }

    searchButton.classList.toggle("is-search", query !== "");
    searchButton.classList.toggle("search-icon", query === "");
  };

  const debouncedSearch = debounce(updateSearchResultsList, 500);

  searchInput.addEventListener("input", () => {
    debouncedSearch();
  });

  searchButton.addEventListener("click", () => {
    if (searchButton.classList.contains("is-search")) {
      clearInput();
    }
  });

  searchButton.classList.add("search-icon");

  window.addEventListener("resize", () => {
    const width = document.body.clientWidth;

    if (width) {
      clearInput();
    }
  });

  function setActiveItem(items) {
    items.forEach((item, index) => { item.classList.toggle("active", index === selectedResultItemIndex); });

    if (selectedResultItemIndex >= 0) {
      items[selectedResultItemIndex].scrollIntoView({ block: "nearest" });
    }
  }

  searchInput.addEventListener("keydown", (event) => {
    const items = Array.from(searchResultsList.children);

    if (items.length) {
      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          selectedResultItemIndex = Math.min(selectedResultItemIndex + 1, items.length - 1);
          setActiveItem(items);
          break;

        case "ArrowUp":
          event.preventDefault();
          selectedResultItemIndex = Math.max(selectedResultItemIndex - 1, 0);
          setActiveItem(items);
          break;

        case "Enter":
          if (selectedResultItemIndex >= 0) {
            event.preventDefault();
            const selectedItem = items[selectedResultItemIndex];
            const link = selectedItem.querySelector("a");
            if (link) {
              window.location.href = link.href;
            }
          }
          break;

        default:
          break;
      }
    }
  });
}

export { searchMaxWidth, searchMenu };